module.exports = __webpack_public_path__ + "img/bg_coating.1e7579f8.png";